@if (summary) {
  <div class="confirmation-wrapper">
    <div class="check-carefully margin-bottom-8">
      <mat-icon>warning</mat-icon>
      <span class="accent">Check carefully!</span>
    </div>
    <div class="margin-bottom-8">
      Are you sure you want to issue <b>{{ summary.type }}</b> adjustment for:
    </div>
    <ul>
      @if (summary.cash) {
        <li>
          {{ summary.cash.delta.value > 0 ? 'CREDIT' : 'DEBIT' }}
          <app-simple-money [data]="absMoney(summary.cash.delta)"></app-simple-money>
          in CASH,
          {{ summary.cash.delta.value > 0 ? 'increasing' : 'decreasing' }} the balance from
          <app-simple-money [data]="summary.cash.before"></app-simple-money> to
          <app-simple-money [data]="summary.cash.after"></app-simple-money>
        </li>
      }
      @if (summary.bonus) {
        <li>
          {{ summary.bonus.delta.value > 0 ? 'CREDIT' : 'DEBIT' }}
          <app-simple-money [data]="absMoney(summary.bonus.delta)"></app-simple-money> in BONUS,
          {{ summary.bonus.delta.value > 0 ? 'increasing' : 'decreasing' }} the balance from
          <app-simple-money [data]="summary.bonus.before"></app-simple-money> to
          <app-simple-money [data]="summary.bonus.after"></app-simple-money>
          for active bonus: {{ summary.bonus.bonusName }}
        </li>
      }
      @if (summary.diamonds) {
        <li>
          {{ summary.diamonds.delta > 0 ? 'CREDIT' : 'DEBIT' }}
          <app-diamonds [value]="absNumber(summary.diamonds.delta)"></app-diamonds>
          (worth <app-simple-money [data]="absMoney(summary.diamonds.deltaWorth)"></app-simple-money>) in DIAMONDS,
          {{ summary.diamonds.delta > 0 ? 'increasing' : 'decreasing' }} the balance from
          <app-diamonds [value]="summary.diamonds.before"></app-diamonds> (worth:
          <app-simple-money [data]="summary.diamonds.beforeWorth"></app-simple-money>) to
          <app-diamonds [value]="summary.diamonds.after"></app-diamonds> (worth:
          <app-simple-money [data]="summary.diamonds.afterWorth"></app-simple-money>)
        </li>
      }
      @if (summary.reserve) {
        <li>
          {{ summary.reserve.delta.value > 0 ? 'CREDIT' : 'DEBIT' }}
          <app-simple-money [data]="absMoney(summary.reserve.delta)"></app-simple-money>
          in RESERVE,
          {{ summary.reserve.delta.value > 0 ? 'increasing' : 'decreasing' }} the balance from
          <app-simple-money [data]="summary.reserve.before"></app-simple-money> to
          <app-simple-money [data]="summary.reserve.after"></app-simple-money>
        </li>
      }
    </ul>
    <div class="summary-field">
      <div>Reason shown internally in the company</div>
      <div>{{ summary.internalReason }}</div>
    </div>
    <div class="summary-field">
      <div>Reason shown PUBLICLY to the player</div>
      <div>{{ summary.externalReason }}</div>
    </div>
    <div class="summary-field summary-field-inline">
      <div class="display-inline">Reference ID(s):</div>
      <div>{{ summary.referenceIds || '' }}</div>
    </div>
    <div class="summary-field summary-field-inline">
      <div>Timestamp:</div>
      <div>{{ timestamp }}</div>
    </div>
    <div class="summary-field primary summary-field-inline">
      <div>Authoriser:</div>
      <div>{{ currentUser.name }}, {{ currentUser.email }}</div>
    </div>
  </div>
}
